/**
 * Blog post registry — single source of truth for the /blog hub, the
 * sitemap, and cross-links. Each post is its own page under
 * src/pages/site/blog/<slug>.tsx; keep this list in lockstep.
 */

export type BlogPost = {
  slug: string;
  title: string;
  description: string;
  /** ISO date, also shown on the page. */
  date: string;
  dateDisplay: string;
  readMinutes: number;
};

export const BLOG_POSTS: BlogPost[] = [
  {
    slug: "stateless-mcp-server-nextjs",
    title:
      "Building a stateless Streamable HTTP MCP server inside a Next.js pages-router app",
    description:
      "How FrazzleCRM ships a Model Context Protocol server from a single Next.js API route — no sessions, no SSE, no separate service — and the design decisions that made AI agents good at using it.",
    date: "2026-07-22",
    dateDisplay: "22 July 2026",
    readMinutes: 9,
  },
  {
    slug: "two-way-sync-diagram-is-the-automation",
    title: "Two-way sync: how the funnel diagram IS the automation",
    description:
      "Most tools treat the diagram as documentation that drifts from the runtime. FrazzleCRM makes the map and the automation one structure — here's the bridge architecture and the sync rules that survived contact with reality.",
    date: "2026-07-22",
    dateDisplay: "22 July 2026",
    readMinutes: 8,
  },
];
